import React from "react";
import "../../../style/allBlogs/allBlogs.css";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import TranslateButton from "../../TranslateButton/TranslateButton";
import augustImage from "../../../images/happy-new-year.jpg";
const AllBlogs = () => {
  return (
    <>
      <Navbar />
      {/* <TranslateButton /> */}
      <div className="allBlogs_section">
        <div className="header_image">
          <p>Home | Blogs</p>
          <h2>ALL Blogs</h2>
        </div>

        <div className="container">
          <h1>All Blogs</h1>
          <div className="allBlogs_wrapper">

            <div className="single_wrapper">
              <div className="image_wrapper">
                <a href="/happy-new-year" target={"_blank"}>
                  <img src={augustImage} alt="" />
                </a>
              </div>
              <div className="image_title">
                <p>January 1, 2026</p>
                <a href="/happy-new-year" target={"_blank"}>
                  Happy New Year – Let the Adventure Begin
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AllBlogs;
